import "../chunk-BUSYA2B4.js";
import hex from "crypto-js/enc-hex";
import sha256 from "crypto-js/sha256";
import { canUseKeyless } from "../utils/feature-flags";
const keylessCookiePrefix = `__clerk_keys_`;
const getKeylessCookieName = () => {
  const PATH = process.env.PWD;
  if (!PATH) {
    return `${keylessCookiePrefix}${0}`;
  }
  const lastThreeDirs = PATH.split("/").filter(Boolean).slice(-3).reverse().join("/");
  const hash = hashString(lastThreeDirs);
  return `${keylessCookiePrefix}${hash}`;
};
function hashString(str) {
  return sha256(str).toString(hex).slice(0, 16);
}
function getKeylessCookieValue(getter) {
  if (!canUseKeyless) {
    return void 0;
  }
  const keylessCookieName = getKeylessCookieName();
  let keyless;
  try {
    if (keylessCookieName) {
      keyless = JSON.parse(getter(keylessCookieName) || "{}");
    }
  } catch {
    keyless = void 0;
  }
  return keyless;
}
export {
  getKeylessCookieName,
  getKeylessCookieValue
};
//# sourceMappingURL=keyless.js.map